import { createElementBlock as l, openBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(c, e) {
  return o(), l("svg", r, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.913 4.986a3.986 3.986 0 1 1 7.97 0v5.029a3.986 3.986 0 0 1-7.97 0zM20 11a1 1 0 1 0-2 0c0 .822-.444 2.085-1.446 3.15-.973 1.036-2.442 1.85-4.46 1.85-2.023 0-3.545-.817-4.568-1.864C6.472 13.06 6 11.8 6 11a1 1 0 0 0-2 0c0 1.43.76 3.17 2.096 4.535C7.46 16.931 9.486 18 12.093 18c2.611 0 4.596-1.072 5.918-2.48C19.305 14.145 20 12.408 20 11m-6.942 9a1 1 0 1 0-2 0v2a1 1 0 0 0 2 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: t };
export {
  i as default,
  t as render
};
//# sourceMappingURL=ic_voice_filled-Be0fy7Kn.js.map
